
import abi from "./contract/GlobalPool.json";

import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Buy3 from "./component/buy3";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import jQuery from "jquery";


import "./logo.png";
import "./Global.gif";
import "./2.png";
import "./3.png";
import "./4.png";
import "./5.png";
import "./6.png";
import "./7.png";
import "./8.png";
import "./9.png";
import "./10.png";
import "./copy.png";


import { useState, useEffect } from "react";
import { ethers } from "ethers";

function App() {

  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  const [account, setAccount] = useState("None");
  
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[auto,setAuto]=useState("None");
  const[auto1,setAuto1]=useState("None");
  const[auto2,setAuto2]=useState("None");
  const[auto3,setAuto3]=useState("None");
  const[auto4,setAuto4]=useState("None");
  const[auto5,setAuto5]=useState("None");
  const[auto6,setAuto6]=useState("None");
  const [tasks1,setTasks1] = useState([]);
  const[auto7,setAuto7]=useState("None");
  const[bonus,setBonus]=useState("None");
  const[bonus1,setBonus1]=useState("None");
  const[pack,setpackage]=useState("None");
  const[refer,setrefer]=useState("None");
const [tasks,setTasks] = useState([]);

const [total,setTotal]=useState("None");
const [req,setreq]=useState("None");
const [tt,settt]=useState("None");
const[dd,setDD]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[bonanza1,setBonanza1]=useState("None");

  const[nauto,setnAuto]=useState("None");
  const[nauto1,setnAuto1]=useState("None");
  const[nauto2,setnAuto2]=useState("None");
  const[nauto3,setnAuto3]=useState("None");
  const[nauto4,setnAuto4]=useState("None");
  const[nauto5,setnAuto5]=useState("None");
  const[nauto6,setnAuto6]=useState("None");
const[wid,setwid]=useState("None");


  useEffect(() => {
    const connectWallet = async () => {
      const contractAddress = "0x7707aad922c6a08f93caed5d526a248b10adab44";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
      const myParam = searchParams.get('ref');
      console.log(myParam);
      
      
      document.querySelector("#name").value=myParam;
  if(myParam == null)
  {
    document.querySelector("#name").value="0x9b908139f4E6F993E6c2CD26D03530A34F4dbf66";
  }
      try {
        const { ethereum } = window;
        document.querySelector("#test").value = "Pay 60";
        if (ethereum) {
          const account = await ethereum.request({
            method: "eth_requestAccounts",
           
          });
         
          window.ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          window.ethereum.on("accountsChanged", () => {
          window.location.reload();
          });

          const provider = new ethers.providers.Web3Provider(ethereum);
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
          let alltasks = await contract.getMemos(account[0]);
          setTasks(alltasks);
           let alltasks1 = await contract.getMemos1(account[0]);
          setTasks1(alltasks1);
          const auto7 = Number(alltasks[3]);
setAuto7(auto7);
          const b =Number(alltasks[2]);
          const refer = (alltasks[1]);
         setrefer(refer);
         document.querySelector("#hid").value  = (alltasks[1]);
         const direct =Number(alltasks[2]);
         setDirect(direct);
         const directs =  Number(alltasks[14])/1000000000000000000;
         setDirects(directs);
         const level = Number(alltasks[15])/1000000000000000000;
         setLevel(level);
         const auto = Number(alltasks[8])/1000000000000000000;
         setAuto(auto);
         const auto1 = Number(alltasks[9])/1000000000000000000;
         setAuto1(auto1);
         const auto2 = Number(alltasks[10])/1000000000000000000;
         setAuto2(auto2);
         
         const auto3 = Number(alltasks[11])/1000000000000000000;
         setAuto3(auto3);
         
         const auto4 = Number(alltasks[15])/1000000000000000000;
         setAuto4(auto4);
         const auto5 = Number(alltasks[15])/1000000000000000000;
         setAuto5(auto5);
         const auto6 = Number(alltasks[4])/1000000000000000000;
         setAuto6(auto6);
        

         const nauto = Number(alltasks[12])/1000000000000000000;
         setnAuto(nauto);
         const nauto1 = Number(alltasks[16]);
         setnAuto1(nauto1);
         const nauto2 = Number(alltasks[17]);
         setnAuto2(nauto2);
         const nauto3 = Number(alltasks[18]);
         setnAuto3(nauto3);
         const nauto4 = Number(alltasks[19]);
         setnAuto4(nauto4);
         const nauto5 = Number(alltasks[20]);
         setnAuto5(nauto5);
         

         
         
         
         
         
         const bonus = Number(alltasks[13]);
         setBonus(bonus);
         const bonus1 = Number(alltasks[21])/1000000000000000000;
         setBonus1(bonus1);
         const total = Number(alltasks[10]);
         setTotal(total);

         const tt = directs + level + bonus + auto + total + auto1 + auto2 + auto3 + auto4 + auto5 + auto6  + bonus1;
         settt(tt);
         
         const pack = Number(alltasks[5]);
         document.querySelector("#pp").value  = Number(alltasks[5]);
         
    
    setpackage(pack);
    const bonanza = Number(alltasks[7]);
         setBonanza(bonanza);
         const bonanza1 = Number(alltasks[20]);
         setBonanza1(bonanza1);
          
         
    const dd = new Date(alltasks[8].timestamp * 1000).toLocaleString();
    setDD(dd);
         setB(b);
         const referlink = 'https://helpinghands.top/?ref='+ account;
         setreflink(referlink);
         document.querySelector("#link").value =referlink;
    
    
    console.log(pack);
   
     
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
     
    
    
    connectWallet();
    
  }, []);

 
  // console.log(state);
        
       
  return (
   
<div >
<input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>

    <section id="portfolio-boxes">
  <div className="pb-header">
    <div className="pb-label ">Dashboard Overview</div>

    <h2 className="pb-title ">
      Your Portfolio at a <span className="gradient-text">Glance</span>
    </h2>

    <p className="pb-sub ">
      Every key metric, income stream, and wallet balance — live, in one
      place.
    </p>
  </div>

  <div className="pb-grid">
    {/* INCOME — Pink */}
    <div className="pb-card pb-pink ">
      <div className="pb-icon">💰</div>
      <div className="pb-pill">Upgrade</div>
      <div className="pb-card-title"><input type ="hidden"  style={{
        width: "80%",
        padding: "12px 16px",
        borderRadius: "12px",
        border: "1px solid rgba(255,255,255,0.15)",
        background: "rgba(255,255,255,0.08)",
        color: "#fff",
        fontSize: "16px",
        
        outline: "none",
        backdropFilter: "blur(10px)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        
      }} id ="test"></input></div>
     

      <div className="pb-action">
         <Buy state={state} />
      </div>
    </div>

    {/* WITHDRAW — Cyan */}
    <div
      className="pb-card pb-cyan "
      style={{ transitionDelay: "0.08s" ,textAlign:"center"}}
    >
      <div style={{
   
    justifyContent: "center",
    alignItems: "center",
    width: "70px",
    height: "70px",
    margin: "0 auto 15px auto",
    borderRadius: "50%",
    background: "rgba(255,255,255,0.08)",
    backdropFilter: "blur(10px)",
    fontSize: "32px",
  }}  className="pb-icon">🏦</div>
      <div className="pb-pill">Re-Entry</div>
      <div className="pb-card-title">Single Leg Positions</div>
    

      <div className="pb-action">
       {auto7} 
      </div>
    </div>

    {/* TOKEN — Blue */}
    <div
      className="pb-card pb-blue "
      style={{ transitionDelay: "0.16s" }}
    >
      <div className="pb-icon">🪙</div>
      <div className="pb-pill">Packages</div>
      <div className="pb-card-title">My Packages</div>
       
      

     <div className="pb-action">
       USDT {pack}
      </div>

     
    
    </div>

    {/* DIRECT — Purple */}
    <div
      className="pb-card pb-purple "
      style={{ transitionDelay: "0.24s" }}
    >
      <div className="pb-icon">👥</div>
      <div className="pb-pill">Income</div>
      <div className="pb-card-title"></div>
     
      <div className="pb-row">
        <span className="pb-row-label">My Direct Income</span>
        <span className="pb-row-value">USDT {directs}</span>
      </div>
      <div className="pb-row">
        <span className="pb-row-label">Single Leg Income</span>
        <span className="pb-row-value">USDT {auto6}</span>
      </div>

      <div className="pb-row">
        <span className="pb-row-label">Royalty</span>
        <span className="pb-row-value">USDT {bonus1}</span>
      </div>

      <div className="pb-row">
        <span className="pb-row-label">Level Income</span>
        <span className="pb-row-value">USDT {auto + auto1 + auto2 + auto3 + nauto}</span>
      </div>

      <div className="pb-row">
        <span className="pb-row-label">Total Income</span>
        <span className="pb-row-value">USDT {level}</span>
      </div>

    </div>
     <div className="pb-card pb-pink ">
      <div className="pb-icon">💰</div>
      <div className="pb-pill">Team</div>
      <div className="pb-card-title"></div>
     
      
       <div className="pb-row">
        <span className="pb-row-label">My Direct Team</span>
        <span className="pb-row-value"> {direct}</span>
      </div>

   
      <div className="pb-row">
        <span className="pb-row-label">Current Week Direct</span>
        <span className="pb-row-value">{bonus}</span>
      </div>

   
    </div>

    {/* WITHDRAW — Cyan */}
    <div
      className="pb-card pb-cyan "
      style={{ transitionDelay: "0.08s" }}
    >
      <div className="pb-icon">🏦</div>
      <div className="pb-pill">Level Income</div>
      <div className="pb-card-title"></div>
     

      <div className="pb-row">
        <span className="pb-row-label">level - I Income</span>
        <span className="pb-row-value">  USDT {auto}</span>
      </div>

      <div className="pb-row">
        <span className="pb-row-label">level - II Income</span>
        <span className="pb-row-value">USDT {auto1}</span>
      </div>

      <div className="pb-row">
        <span className="pb-row-label">Level - III Income</span>
        <span className="pb-row-value"> USDT {auto2}</span>
      </div>
      <div className="pb-row">
        <span className="pb-row-label">Level - IV Income</span>
        <span className="pb-row-value">  USDT {auto3}</span>
      </div>

      <div className="pb-row">
        <span className="pb-row-label">level - V Income</span>
        <span className="pb-row-value">USDT {nauto}</span>
      </div>

      
      
    </div>

<div
      className="pb-card pb-blue "
      style={{ transitionDelay: "0.16s" }}
    >
      <div className="pb-icon">🪙</div>
      <div className="pb-pill">Level Team</div>
      <div className="pb-card-title"></div>
       
<div className="pb-row">
        <span className="pb-row-label">Level - I</span>
        <span className="pb-row-value">{nauto1}</span>
      </div>
       <div className="pb-row">
        <span className="pb-row-label">Level - II</span>
        <span className="pb-row-value">{nauto2}</span>
      </div>
      <div className="pb-row">
        <span className="pb-row-label">Leevel - III</span>
        <span className="pb-row-value">{nauto3}</span>
      </div>

      <div className="pb-row">
        <span className="pb-row-label">Level - IV</span>
        <span className="pb-row-value">{nauto4}</span>
      </div>

      <div className="pb-row">
        <span className="pb-row-label">Level - V</span>
        <span className="pb-row-value">{nauto5}</span>
      </div>

            

     
    
    </div>

    {/* TOKEN — Blue */}
    <div
      className="pb-card pb-purple "
      style={{ transitionDelay: "0.24s" }}
    >
      <div className="pb-icon">🪙</div>
      <div className="pb-pill">Welcome To Helping Hands :</div>
      <div style={{wordBreak:"break-all"}} className="pb-card-title">Connected Account: {account}</div>
     
    </div>

    {/* DIRECT — Purple */}
    <div
      className="pb-card pb-pink "
      style={{ transitionDelay: "0.24s",textAlign:"center" }}
    >
      <div  style={{
   
    justifyContent: "center",
    alignItems: "center",
    width: "70px",
    height: "70px",
    margin: "0 auto 15px auto",
    borderRadius: "50%",
    background: "rgba(255,255,255,0.08)",
    backdropFilter: "blur(10px)",
    fontSize: "32px",
  }} className="pb-icon">👥</div>
      <div className="pb-pill">Referlink</div>
      <div className="pb-card-title"> {referlink}<button onClick={() => navigator.clipboard.writeText(referlink)} style={{
    backgroundColor: "#ef57a8",
    color: "#fff",
    padding: "10px 40px",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    cursor: "pointer",
    transition: "0.3s",
  }}>
    
Copy  
</button></div>
     
    </div>
     <div style={{textAlign:"center"}} className="pb-card pb-pink ">
      <div   style={{
   
    justifyContent: "center",
    alignItems: "center",
    width: "70px",
    height: "70px",
    margin: "0 auto 15px auto",
    borderRadius: "50%",
    background: "rgba(255,255,255,0.08)",
    backdropFilter: "blur(10px)",
    fontSize: "32px",
  }} className="pb-icon">💰</div>
      <div className="pb-pill">My Refer :</div>
      <div className="pb-card-title">{refer}</div>
      

      
    </div>

    
    
  </div>
</section>
   
                       
    </div>                      
  
  );
}

export default App;
